import { render, staticRenderFns } from "./DataTableMainServer.vue?vue&type=template&id=be6172b2&"
import script from "./DataTableMainServer.vue?vue&type=script&lang=js&"
export * from "./DataTableMainServer.vue?vue&type=script&lang=js&"
import style0 from "./DataTableMainServer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports